export default __webpack_public_path__ + "static/media/zink-plate.41e1f8c2.svg";